// This file configures React's scheduling mechanism to help resolve the "No lowest priority node found" error
// Environment variables for controlling React's scheduler
if (typeof window !== 'undefined') {
  window.__REACT_SCHEDULER_PRIORITY_SETTINGS__ = {
    // Configure React to use synchronous scheduling for improved stability
    enableSynchronousPriority: true
  };
}